// extracted by mini-css-extract-plugin
export default {"overlay":"zA-z","bodyOpen":"AA-z","content":"BA-z","header":"CA-z","close":"DA-z","closeNoHeading":"EA-z"};